import React, { useEffect } from "react";
import { X } from "lucide-react";
import { useTheme } from "../../contexts/ThemeContext";

const GenericModal = ({
  isOpen,
  onClose,
  title,
  children,
  footer,
  maxWidth = "max-w-lg"
}) => {
  const { colors } = useTheme();

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") onClose();
    };
    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "unset";
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm transition-all duration-300 animate-in fade-in">
      <div
        className={`${colors.cardBg} ${colors.cardBorder} border rounded-3xl sm:rounded-[2.5rem] shadow-2xl w-full ${maxWidth} max-h-[90vh] flex flex-col overflow-hidden transform transition-all duration-300 scale-100 animate-in zoom-in-95 duration-200`}
      >
        {/* Header */}
        <div className="p-4 sm:p-6 md:p-8 flex items-center justify-between gap-3 border-b border-white/5 shrink-0">
          <h3 className={`text-lg sm:text-xl font-bold min-w-0 truncate ${colors.textPrimary}`}>{title}</h3>
          <button
            onClick={onClose}
            className={`p-2 rounded-xl h-10 w-10 flex items-center justify-center shrink-0 ${colors.bgHoverStrong} transition-colors border ${colors.border}`}
          >
            <X className={`w-5 h-5 ${colors.textSecondary}`} />
          </button>
        </div>

        {/* Content */}
        <div className="p-4 sm:p-6 md:p-8 overflow-y-auto custom-scrollbar min-h-0 flex-1">
          {children}
        </div>

        {/* Footer */}
        {footer && (
          <div className="p-4 sm:p-6 md:p-8 border-t border-white/5 bg-white/5 shrink-0">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

export default GenericModal;
